import React from 'react';
import { FadeIn } from './FadeIn';
import { User, TrendingUp, Rocket } from 'lucide-react';
export function ParaQuien() {
  const targets = [{
    icon: <User className="w-10 h-10 text-brand-green" data-id="element-464" />,
    title: 'Soy principiante',
    desc: 'Empieza desde cero.'
  }, {
    icon: <TrendingUp className="w-10 h-10 text-brand-green" data-id="element-465" />,
    title: 'Ya vendo',
    desc: 'Aprende a combinar FBA y FBM.'
  }, {
    icon: <Rocket className="w-10 h-10 text-brand-green" data-id="element-466" />,
    title: 'Quiero ingresos online',
    desc: 'Sigue un sistema paso a paso.'
  }];
  return <section className="bg-brand-beige/50 py-20 md:py-32 px-4 sm:px-6" data-id="element-467">
      <div className="max-w-5xl mx-auto" data-id="element-468">
        <FadeIn data-id="element-469">
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl font-bold text-brand-green text-center mb-16 tracking-tight" data-id="element-470">
            ¿Este curso es para ti?
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-471">
          {targets.map((t, i) => <FadeIn key={i} delay={0.1 * i} data-id="element-472">
              <div className="bg-white rounded-[2rem] p-10 text-center shadow-[0_15px_40px_-15px_rgba(0,0,0,0.08)] border border-brand-text/5 h-full" data-id="element-473">
                <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-brand-green/5 mb-8" data-id="element-474">
                  {t.icon}
                </div>
                <h3 className="text-2xl font-bold text-brand-green mb-4" data-id="element-475">
                  {t.title}
                </h3>
                <p className="text-brand-text/70 text-lg" data-id="element-476">{t.desc}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}